import { c as _c } from "react/compiler-runtime";
import { Heading, Image, VStack, Wrap } from '@chakra-ui/react';
import { TrustPilotStars } from '@src/components/sco/TrustPilotStars';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import React from 'react';
export type PricingKeyStatsProps = {};
const items = [{
  imageSrc: '/assets/icons/accelerator/rocket.svg',
  label: '1M+ Startups'
}, {
  imageSrc: '/assets/icons/accelerator/invest.svg',
  label: '$700M+ Raised'
}, {
  component: <TrustPilotStars marginBottom={1} maxWidth={'100px'} />,
  label: '4.8 on TrustPilot'
}, {
  component: <Image maxWidth={'220px'} src={'/assets/pricing/review.png'} />
}];
export const PricingKeyStats: React.FC<PricingKeyStatsProps> = props => {
  const $ = _c(1);
  useBreakpointContext();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Wrap gap={4} justify="center">{items.map(_temp)}</Wrap>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(item, index) {
  return <VStack key={index} align="center" borderColor="colorPalette.border" justify="center" paddingX={8}>{item.component || <Image alt={item.label} height={8} src={item.imageSrc} width="auto" />}{item.label && <Heading color="purpleLightAlpha.600" size="md" textAlign="center">{item.label}</Heading>}</VStack>;
}